import React from 'react';
import { motion } from 'framer-motion';

const cardData = [
    {
        id: 1,
        image: "/assets/awards/img1.png",
        tag: "No. 1 in our industry for 13 years",
        title: "Fortune World's Most Admired Companies",
        link: "#"
    },
    {
        id: 2,
        image: "/assets/awards/img2.png",
        tag: "No. 1 in our industry for 13 years",
        title: "Fortune World's Most Admired Companies",
        link: "#"
    }
];

const FortuneCards = () => {
    return (
        <section className="w-full py-10 md:py-24 bg-[#F1F1F1]">
            <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10 px-[20px] md:px-[40px] lg:px-[80px]">
                {cardData.map((card) => (
                    <motion.div
                        key={card.id}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="group w-full overflow-hidden flex flex-col relative rounded-sm"
                    >
                        <div className="w-full h-[200px] sm:h-[260px] md:h-[300px] lg:h-[350px] overflow-hidden">
                            <img
                                src={card.image}
                                alt="Award Visual"
                                className="w-full h-full object-cover transition-transform duration-700 md:group-hover:scale-105"
                            />
                        </div>

                        <div className="bg-[#FFFFFF] border-l border-r border-b border-[#BAC9D7] p-5 sm:p-8 md:p-10 flex-grow flex flex-col justify-between">
                            <div>
                                <p className="font-graphik text-[#ED6800] text-[14px] md:text-[16px] font-[500] font-graphik mb-2 sm:mb-3">
                                    {card.tag}
                                </p>
                                <h3 className="font-sora text-[#01386A] max-w-full sm:max-w-[302px] w-full text-[16px] md:text-[20px] font-[600] leading-tight mb-4 sm:mb-6">
                                    {card.title}
                                </h3>
                            </div>
                            <a
                                href={card.link}
                                className="font-graphik text-[#01386A] text-[14px] sm:text-[16px] font-[500] flex items-center gap-2 hover:text-[#ED6800] transition-colors mt-auto w-fit"
                            >
                                Read More <span>&gt;</span>
                            </a>
                        </div>
                        <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-20"></div>
                        <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-30"></div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default FortuneCards;